import { render, staticRenderFns } from "./AdFormSiteheader.vue?vue&type=template&id=35305041&"
import script from "./AdFormSiteheader.vue?vue&type=script&lang=ts&"
export * from "./AdFormSiteheader.vue?vue&type=script&lang=ts&"
import style0 from "./AdFormSiteheader.vue?vue&type=style&index=0&id=35305041&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports